export default __webpack_public_path__ + "static/media/ronnie.269c9dda.jpg";